import { render, staticRenderFns } from "./contract-detail-paper.vue?vue&type=template&id=676e5f9e&scoped=true"
import script from "./contract-detail-paper.vue?vue&type=script&lang=js"
export * from "./contract-detail-paper.vue?vue&type=script&lang=js"
import style0 from "./contract-detail-paper.vue?vue&type=style&index=0&id=676e5f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676e5f9e",
  null
  
)

export default component.exports